import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { resetPW } from "../services/apiService";
import type { AppDispatch } from "../stores/AppStore";

function Reset() {
    const dispatch = useDispatch<AppDispatch>();
    const tokenParam = useParams();
    const navigate = useNavigate();
    const times = useRef(0);
    let token;
    useEffect(() => {
        if (times.current++ === 0) {
            if (tokenParam) {
                token = (tokenParam as {token: string}).token?.replace(/:/, "");
                dispatch(resetPW({authtoken: token})).then(() => {
                    navigate('/profile/:reset');
                });
            }
        }
    }, []);
    return (
        <div>
            Reset {token}
        </div>
    );
}
export default(Reset);
